/**
 * Returns a border radius scale multiplier for use in MUI's sx prop.
 *
 * The returned value is automatically multiplied by the base border radius
 * defined in theme.shape.borderRadius (default: 8px).
 *
 * @example
 * <Box sx={{ borderRadius: borderRadius('s') }} /> // Results in 4px (0.5 * 8px)
 */
function borderRadius(size: 's' | 'm' | 'l' | 'xl') {
  switch (size) {
    case 's':
      return 0.5;
    case 'm':
      return 1;
    case 'l':
      return 1.5;
    case 'xl':
      return 30;
    default:
      return 0.5;
  }
}

/**
 * Returns an absolute border radius value in pixels.
 *
 * It multiplies the provided `base` value with the border radius scale multiplier for the given `size`.
 * This is useful when you need to opt-out from the default theme border radius.
 *
 * @example
 * <Box sx={{ borderRadius: borderRadius.abs(10, 's') }} /> // Results in '5px' (10 * 0.5)
 */
borderRadius.abs = (base: number, size: 's' | 'm' | 'l' | 'xl') => {
  return `${base * borderRadius(size)}px`;
};

export { borderRadius };
